import { BOOKING_URL } from '@/lib/building-tier'
import { SITE } from '@/lib/site-config'

// Content of the /$locale/links page (the CountAct "link in bio", replacing
// the former Linktree). Labels live in messages/{fr,en}.json under
// `links.items` / `links.socials`, keyed by `id`; edit both when adding an entry.

export type MainLinkIcon = 'calendar' | 'globe'

export type MainLink = {
  id: 'meeting' | 'website'
  icon: MainLinkIcon
  // Exactly one entry is highlighted: it renders as the solid blue button.
  highlight?: boolean
} & ({ href: string } | { internal: '/$locale' })

export const MAIN_LINKS: readonly MainLink[] = [
  {
    id: 'meeting',
    icon: 'calendar',
    highlight: true,
    // Same booking page as the trial and audit emails.
    href: BOOKING_URL,
  },
  { id: 'website', icon: 'globe', internal: '/$locale' },
]

export type SocialLink = {
  id: 'linkedin' | 'email' | 'googlePlay' | 'appStore'
  href: string
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  { id: 'linkedin', href: SITE.linkedin },
  { id: 'email', href: SITE.emailHref },
  { id: 'googlePlay', href: 'https://play.google.com/store/apps/details?id=fr.countact.evacapp' },
  { id: 'appStore', href: 'https://apps.apple.com/fr/app/countact/id1635365396' },
]

export const LINKS_PATH = '/links'
